import styled from 'styled-components';
import {Button, Card} from 'global/styles/styles.js';

const Header = ({ theme: { header } }) => header();
const CardBody = ({ theme: { cardBody } }) => cardBody();
const CardTab = ({ theme: { cardTab } }) => cardTab();
const CardLabel = ({ theme: { cardLabel } }) => cardLabel();
const Divider = ({ theme: { divider } }) => divider();
const CardWithTab = ({ theme: { cardWithTab } }) => cardWithTab();
const Link = ({ theme: { link } }) => link();

const S = {};

S.AccountCurrentBonus = styled.div`
    width: calc(100% - 1rem);
    padding: 0 0.5rem;
`;

S.ActiveBonusRow = styled.div``;

S.BonusHeader = styled.h4` ${Header} `;

S.BonusBox = styled.div`
    display:flex;
    justify-content:space-between;
    width:100%;
    padding: 0.45rem 0.75rem 0.45rem;
`;

S.BonusOffrImg = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
`;

S.BonusBody = styled.div`${CardBody}`;

S.BonusContent = styled(Card)` ${CardWithTab};
    justify-content: center;
`;

S.BonusImageWrapper = styled.div` ${CardTab}
    position: relative;
    padding-top: ${p => `calc(100% / ${p.ratio})`};
    min-height: unset;
    overflow: hidden;
`;

S.BonusTitle = styled.div`${CardLabel}`;

S.BonusValue = styled.div`${CardLabel};
    font-weight: 700;
`;
S.Divider = styled.div`${Divider}`;

S.Link = styled.a`${Link};
    margin: 1rem 0 0.1rem;
`;

S.BonusList = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
`;

S.NoResult = styled.div`
    height: 2.5rem;
    text-align: center;
    color: ${({theme:{$noResultColor}}) => $noResultColor};
`;

S.ActivateModal = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: -30px;
    color: #000;
`;

S.BtnsWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

S.ButtonCancel = styled(Button)`
    color: #fff;
    border: none;
    height: 2.625rem;
    border-radius: 0.1875rem;
    box-shadow: none;
    padding: 0 0.75rem;
    margin-right: 1rem;
    margin-top: 1rem;
    flex: 1;
    background: ${({theme:{$accountProfileBonusModalsCancelBttnBg}})=> $accountProfileBonusModalsCancelBttnBg};
   
`;
S.ButtonAccept = styled(S.ButtonCancel)`
    margin-right: 0;
    border: 1px solid ${({theme:{$accountProfileBonusModalsAcceptBorderBttnBg}})=> $accountProfileBonusModalsAcceptBorderBttnBg};
    color: ${({theme:{$accountProfileBonusModalsAcceptBttnColor}})=> $accountProfileBonusModalsAcceptBttnColor};
    background: ${({theme:{$accountProfileBonusModalsSuccessBttnBg}})=> $accountProfileBonusModalsSuccessBttnBg};
`;

S.Title = styled.div`
    font-size: 1.230rem;
    letter-spacing: .5px;
    font-weight: 600;
    line-height: 2rem;
    text-align: center;
`;
S.Description = styled.div`
    text-align: center;
`;

S.ModalInfo = styled.div`
    width: 100%;
    margin-top: -44px;
`;

S.InfoTitle = styled.h4`
    color: #000;
    text-transform: uppercase;
    font-size: 1.83rem;
    padding: 0;
    font-weight: 800;
    text-align: center;
    margin-bottom: 2rem;
`;

S.InfoDescription = styled.div`
    color: #000;
    text-align: center;
`;

S.BonusFooter = styled.div`
  text-align: center;
  padding-top: 0.9375rem;
`;

S.BonusRegulationLink = styled.a`
  font-size: 0.75rem;
  color: ${({theme:{$accountProfileBonusRegulationLinkColor}})=> $accountProfileBonusRegulationLinkColor}; 
  text-decoration: underline;
`;

export default S;